// Expõe a cor de frente da sidebar para componentes que precisam dela em JS, e
// não em CSS: o `icon-svg` cai em `v-icon` nos ícones `mdi-*`, que não resolvem
// `currentColor` — a cor precisa chegar como prop.
import { navForeground } from '@modules/navegacao-v2/utils/nav-surface'

export default {
  computed: {
    navFg() {
      return navForeground(this.$Color()['bg-navbar'])
    },
  },
}
